import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import Logo from "@/components/Logo";
import { useSectionNav } from "@/components/Navbar";
import { useLang } from "@/i18n/LanguageContext";

export default function Footer({ settings }) {
  const { t } = useLang();
  const goSection = useSectionNav();

  return (
    <footer data-testid="main-footer" className="bg-[#0B2E4A] text-[#F1E7D6]/60 py-14 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          <Logo dark />
          <p className="mt-4 text-sm max-w-xs leading-relaxed">{t("footer.tagline")}</p>
        </div>
        <nav className="flex flex-col gap-2.5 text-sm font-semibold">
          <Link to="/viaje-a-medida" data-testid="footer-link-medida" className="hover:text-[#D9A854] transition-colors">
            {t("nav.medida")}
          </Link>
          <Link to="/viajes-en-grupo" data-testid="footer-link-grupo" className="hover:text-[#D9A854] transition-colors">
            {t("nav.dates")}
          </Link>
          <Link to="/concierge-casamentos" data-testid="footer-link-casamentos" className="hover:text-[#D9A854] transition-colors">
            {t("nav.casamentos")}
          </Link>
          <Link to="/lua-de-mel" data-testid="footer-link-honeymoon" className="hover:text-[#D9A854] transition-colors">
            {t("nav.honeymoon")}
          </Link>
          <Link to="/quiz" data-testid="footer-link-quiz" className="hover:text-[#D9A854] transition-colors">
            {t("nav.quiz")}
          </Link>
          <Link to="/brasil" data-testid="footer-link-brasil" className="hover:text-[#D9A854] transition-colors">
            {t("nav.brasil")}
          </Link>
          <Link to="/mi-viaje" data-testid="footer-link-miviaje" className="hover:text-[#D9A854] transition-colors">
            {t("nav.miViaje")}
          </Link>
          <button data-testid="footer-link-contacto" onClick={() => goSection("contacto")} className="text-left hover:text-[#D9A854] transition-colors">
            {t("nav.contact")}
          </button>
        </nav>
        <div className="flex flex-col gap-3 text-sm">
          {settings?.instagram && (
            <a
              data-testid="footer-instagram-link"
              href={settings.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-[#D9A854] transition-colors font-semibold"
            >
              <Instagram size={16} className="text-[#D9A854]" /> Instagram Brasil
            </a>
          )}
          {settings?.instagram_it && (
            <a
              data-testid="footer-instagram-it-link"
              href={settings.instagram_it}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-[#D9A854] transition-colors font-semibold"
            >
              <Instagram size={16} className="text-[#D9A854]" /> Instagram Italia
            </a>
          )}
          <Link to="/admin" data-testid="footer-admin-link" className="text-xs uppercase tracking-[0.15em] font-bold text-[#F1E7D6]/35 hover:text-[#D9A854] transition-colors">
            {t("footer.admin")}
          </Link>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 mt-10 pt-6 border-t border-white/5 text-xs text-[#F1E7D6]/35 flex flex-col sm:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} {t("footer.rights")}</span>
        <span data-testid="footer-cadastur">{t("footer.madeFor")}</span>
      </div>
    </footer>
  );
}
